"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settings = void 0;
// Set global.oclif to the new object if it wasn't set before
if (!global.oclif)
    global.oclif = {};
exports.settings = global.oclif;
